import { AgGridReact } from '@ag-grid-community/react';
import { usePunchReport } from '../../Hooks/Features/HrLens/usePunchReport';
import { SkeletonDataTable } from '../Loader/Loader';
import { ClientSideRowModelModule } from "@ag-grid-community/client-side-row-model";
import { ModuleRegistry } from "@ag-grid-community/core";
import { RowGroupingModule } from "@ag-grid-enterprise/row-grouping";
ModuleRegistry.registerModules([ClientSideRowModelModule, RowGroupingModule]);

const PunchReport = ({filterValues, hoveredRange, callPunchApi, setCallPunchApi}) => {

    const { rowData, colDef, loader } = usePunchReport({filterValues, hoveredRange, callPunchApi, setCallPunchApi});

    return (
        <div>
            <div className="ag-theme-alpine mt-2" style={{ height: "calc(100vh - 110px)" }}>
                {loader ? <div style={{ height: "100%" }}><SkeletonDataTable numSkeletons={21} /></div> :
                    <AgGridReact columnDefs={colDef} rowData={rowData} headerHeight={60} rowHeight={30} autoGroupColumnDef={{ pinned: "left", hide: true, width: 200 }} groupDefaultExpanded="-1" />
                }
            </div>
        </div>
    )
}

export default PunchReport